import React, { ReactElement, useState } from "react";
import { Drawer } from "antd";
import { DrawerStyles } from "antd/es/drawer/DrawerPanel";

type CustomDrawerProps = {
  component: React.ElementType; // Allows passing any component to render inside Drawer
  componentProps?: any; // Props for the dynamic component inside the Drawer
  title?: string; // Optional drawer title
  size?: "default" | "large"; // Drawer size
  trigger: ReactElement; // The dynamic trigger component
  width?: number;
  height?: number; // Optional height for the drawer
  placement?: "left" | "right" | "top" | "bottom"; // Optional placement of the drawer
};

const drawerStyles: DrawerStyles = {
  mask: {
    transition: "opacity 0.3s ease-in-out",
  },
  content: {
    transition: "transform 0.3s ease-in-out",
  },
};

const CustomDrawer: React.FC<CustomDrawerProps> = ({
  component: Component,
  componentProps,
  title,
  size,
  width,
  height,
  trigger,
  placement = "right", // Dynamic trigger component
}) => {
  const [open, setOpen] = useState(false);

  const showDrawer = () => setOpen(true);
  const closeDrawer = () => setOpen(false);

  // Clone the trigger element and add the `onClick` event to open the drawer
  const TriggerComponent = React.cloneElement(
    trigger as React.ReactElement<{ onClick: () => void }>,
    { onClick: showDrawer }
  );

  return (
    <>
      {TriggerComponent} {/* Trigger to open the Drawer */}
      <Drawer
        maskClosable={false}
        keyboard={false}
        placement={placement}
        width={size === "default" ? 378 : size === "large" ? 620 : width}
        size={size}
        height={height ? `${height}%` : "378px"}
        title={title || null}
        onClose={closeDrawer}
        open={open}
        styles={drawerStyles}
        destroyOnClose
        footer={null} // No footer
      >
        {/* Render passed component with onCloseDrawer method */}
        <Component
          {...componentProps}
          onCloseDrawer={closeDrawer}
        />
      </Drawer>
    </>
  );
};

export default CustomDrawer;
